<!-- 
 01-01-2025
 Copyright (c) 2016 Aruba. All Rights Reserved.  
 -->
<form name="codeForm" role="form" novalidate (ngSubmit)="submitCode()" [formGroup]="codeForm">
    <div class="modal-body">
        <div class="row">
            <div class="col-md-12">
                <div class="font-14">
                    <ng-container *ngIf="disableModifica">
                        <span [innerHTML]="descriptionText"></span>
                    <br/>
                        <span [innerHTML]="descLinkSmsText">Non puoi usare l'app Aruba PEC?</span>
                        <button type="button" class="ps-0 btn btn-14 btn-link" (click)="selectedRetryMethod()"
                        [innerHTML]="linkSmsText">Usa un metodo senza app</button>
                    </ng-container>
                    <ng-container *ngIf="!disableModifica">
                        <span [innerHTML]="descriptionText"></span>
                        <a href="{{ urlModifica }}" [innerHTML]="modificaloButtonTxt" ></a>
                    </ng-container>
                    <br/><br/>
                </div>
                <div class="form-group">
                    <label class="font-14" [innerHTML]="verifyCodeLabelText">Codice di verifica</label>
                    <div class="form-row">
                        <div class="col-12 col-md-8">
                            <ap-extended-input *ngIf="serialNumberView" controlName="code" 
                            [events]="eventsFocus.asObservable()" initInputType="serialnumber"> </ap-extended-input>
                            <ap-extended-input *ngIf="!serialNumberView" controlName="code" 
                            [events]="eventsFocus.asObservable()"> </ap-extended-input>
                            <ng-container >
                                <div class="form-text text-danger" *ngIf="codeForm.get('code')!.errors?.serverError">
                                    {{ codeForm.get('code')!.errors?.serverError | translate }}
                                </div>
                            </ng-container>
                        </div>
                        <div class="col-lg col-12 mt-lg-0 mt-2">
                            <ng-container *ngIf="!disableRequestNewCode">
                                <span class="mb-0" [innerHTML]="requestNewCodeText"></span>
                                <button type="button" class="mb-1 p-0 btn btn-link" 
                                [innerHTML]="requestNewCodeLinkText" (click)="requestNewVerificationCode()"></button>
                            </ng-container>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer justify-content-start">
        <button type="submit" class="btn-small  col-md-3 col-12 btn btn-primary position-relative" 
        [disabled]="!codeForm.get('code')!.value">
            <ngx-spinner name="verifyCodeBtn" size="small" [fullScreen]="false" type="ball-clip-rotate"></ngx-spinner>
            <span [innerHTML]="submitButtonText"></span>
        </button>
        <button type="button" class="ms-lg-3 ml-md-3 col-md-3 col-12 btn-small btn btn-primary position-relative" 
            (click)="goBack()" [innerHTML]="backButtonTxt"></button>
    </div>
</form>
